import { track } from '@vercel/analytics'
import {
  IOS_APP_STORE_URL,
  IOS_APP_STORE_BADGE_SRC,
  ANDROID_PLAY_STORE_URL,
  ANDROID_PLAY_STORE_BADGE_SRC,
} from '../lib/appStoreLinks'

// Sized to Apple's official 246x82 badge so iOS and Android sit at the same height.
const BADGE_HEIGHTS = {
  xs: 42,
  sm: 56,
  md: 68,
  lg: 82,
}

const AppStoreBadges = ({ source = 'unknown', size = 'md', align = 'center', className = '' }) => {
  const handleTrack = (platform) => {
    try {
      track(`App Store Click - ${platform}`, { source })
    } catch (err) {
      // analytics is best-effort
    }
  }

  const height = BADGE_HEIGHTS[size] || BADGE_HEIGHTS.md
  const width = Math.round(height * (246 / 82))

  const justifyClass = align === 'left'
    ? 'justify-center sm:justify-start'
    : align === 'right'
      ? 'justify-center sm:justify-end'
      : 'justify-center'

  return (
    <div className={`flex flex-col sm:flex-row items-center gap-4 ${justifyClass} ${className}`}>
      <a
        href={IOS_APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => handleTrack('iOS')}
        aria-label="Download Prosperia CRM on the App Store"
        tabIndex={0}
        className="inline-block transition-transform duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/60 rounded-xl"
        style={{ lineHeight: 0 }}
      >
        <img
          src={IOS_APP_STORE_BADGE_SRC}
          alt="Download on the App Store"
          width={width}
          height={height}
          style={{ width: `${width}px`, height: `${height}px`, objectFit: 'contain', verticalAlign: 'middle' }}
        />
      </a>

      <a
        href={ANDROID_PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => handleTrack('Android')}
        aria-label="Get Prosperia CRM on Google Play"
        tabIndex={0}
        className="inline-block transition-transform duration-300 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white/60 rounded-xl"
        style={{ lineHeight: 0 }}
      >
        <img
          src={ANDROID_PLAY_STORE_BADGE_SRC}
          alt="Get it on Google Play"
          width={width}
          height={height}
          style={{ width: `${width}px`, height: `${height}px`, objectFit: 'contain', verticalAlign: 'middle' }}
        />
      </a>
    </div>
  )
}

export default AppStoreBadges
